/* eslint-disable jsx-a11y/anchor-is-valid */
import { Route, Link, Routes, Outlet } from 'react-router-dom'
import { Error500 } from './components/Error500'
import NotFound from '../../pages/notFound/NotFound'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { useIntl } from 'react-intl'
import { useFeature } from '../../../Utils/featureFlagEngine'

const ErrorsLayout = () => {
  const { getMainRoute } = useFeature()
  const intl = useIntl()
  return (
    <div className='d-flex flex-column flex-root'>
      <div
        className='bgi-position-y-bottom bgi-attachment-fixed d-flex flex-column flex-column-fluid position-x-center bgi-no-repeat bgi-size-contain'
        style={{ backgroundImage: `url('${toAbsoluteUrl('/media/illustrations/progress-hd.png')}')` }}
      >
        <div className='d-flex flex-column flex-column-fluid py-lg-20 p-10 text-center'>
          <a href={getMainRoute() || ""} className='mb-10 pt-lg-20'>
            <img alt='Logo' src={toAbsoluteUrl('/splashLogo.png')} className='mb-5 h-50px' />
          </a>
          <div className='mb-10 pt-lg-10'>
            <Outlet />
            <div className='text-center'>
              <Link to='/' className='btn btn-lg btn-primary fw-bolder'>
                {intl.formatMessage({ id: 'Go to homepage' })}
              </Link>
            </div>
          </div>
          <div
            className='bgi-position-y-bottom d-flex flex-row-auto min-h-100px min-h-lg-350px bgi-no-repeat bgi-position-x-center bgi-size-contain'
            style={{
              backgroundImage: `url('${toAbsoluteUrl('/media/illustrations/sketchy-1/17.png')}')`,
            }}
          ></div>
        </div>

        <div className='d-flex flex-center flex-column-auto p-10'>
          <div className='d-flex align-items-center fw-bold fs-6'>
            <a href='#' className='px-2 text-hover-primary text-muted'>
              {intl.formatMessage({ id: 'About' })}
            </a>
            <a href='#' className='px-2 text-hover-primary text-muted'>
              {intl.formatMessage({ id: 'Contact' })}
            </a>
            <a href='#' className='px-2 text-hover-primary text-muted'>
              {intl.formatMessage({ id: 'Contact Us' })}
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

const ErrorsPage = () => (
  <Routes>
    {/* 404 renders the self-contained Not Found page (its own logo + actions) */}
    <Route path='404' element={<NotFound showLogo />} />
    <Route index element={<NotFound showLogo />} />
    <Route element={<ErrorsLayout />}>
      <Route path='500' element={<Error500 />} />
    </Route>
  </Routes>
)

export { ErrorsPage }
